import React from 'react';
import {FilterComponent} from '../../config/reportTypes';
import {componentRegistry} from './ComponentRegistry';

interface LoadInputTypeProps {
  comp: FilterComponent;
  value: any;
  onChange: (val: any) => void;
  inputClass?: string;
}

const LoadInputType: React.FC<LoadInputTypeProps> = ({
  comp,
  value,
  onChange,
}) => {
  switch (comp.input_type) {
    case 'datePicker':
      return (
        <React.Fragment key={comp.key}>
          <componentRegistry.datePicker
            value={value}
            onChange={onChange}
            {...comp}
          />
        </React.Fragment>
      );
    case 'dropdown':
      return (
        <React.Fragment key={comp.key}>
          <componentRegistry.dropdown
            value={value}
            onChange={onChange}
            {...comp}
          />
        </React.Fragment>
      );
    case 'multiselectdropdown':
      return (
        <React.Fragment key={comp.key}>
          <componentRegistry.multiselectdropdown
            value={value}
            onChange={onChange}
            {...comp}
          />
        </React.Fragment>
      );

    case 'checkboxList':
      return (
        <React.Fragment key={comp.key}>
          <componentRegistry.checkboxList onChange={onChange} {...comp} />
        </React.Fragment>
      );

    case 'exportFormatMenu':
      return (
        <React.Fragment key={comp.key}>
          <componentRegistry.exportFormatMenu
            {...comp}
            onChange={onChange}
            selectedValue={value || (comp as any).selectedValue}
          />
        </React.Fragment>
      );

    case 'button':
      return (
        <React.Fragment key={comp.key}>
          <componentRegistry.button type="submit" {...comp} />
        </React.Fragment>
      );
    case 'arrSourceSelectedSection':
      return (
        <React.Fragment key={comp.key}>
          <componentRegistry.arrSourceSelectedSection
            onChange={onChange}
            {...comp}
          />
        </React.Fragment>
      );
    case 'checkbox':
      return (
        <React.Fragment key={comp.key}>
          <componentRegistry.checkbox
            checked={value}
            onChange={onChange}
            {...comp}
          />
        </React.Fragment>
      );
    case 'toggle':
      return (
        <React.Fragment key={comp.key}>
          <componentRegistry.toggle
            value={value}
            onChange={onChange}
            {...comp}
          />
        </React.Fragment>
      );

    case 'radioGroup':
      return (
        <React.Fragment key={comp.key}>
          <componentRegistry.radioGroup
            {...comp}
            value={value}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              onChange?.(event.target.value)
            }
            options={comp.options || []}
            name={comp.name}
            size={comp.size}
          />
        </React.Fragment>
      );

    case 'multiSelectTreeViewList':
      return (
        <React.Fragment key={comp.key}>
          <componentRegistry.multiSelectTreeViewList
            value={value}
            onChange={onChange}
            {...comp}
          />
        </React.Fragment>
      );
    case 'textField': // ✅ New case for input box
      return (
        <React.Fragment key={comp.key}>
          <componentRegistry.textField
            {...comp}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              onChange?.(event.target.value)
            }
          />
        </React.Fragment>
      );
    default:
      return null;
  }
};

export default LoadInputType;
